/**
 * State
 * @type {Object}
 */
 const state = {
    events: []
}

/**
 * Getters
 * @type {Object}
 */
const getters = {}

/**
 * Actions
 * @type {Object}
 */
const actions = {

    on({commit}, {event, listener}) {
        commit('add', {event, listener});
    },

    off({commit}, {event, listener}) {
        commit('remove', {event, listener});
    },

    emit({commit}, event) {
        commit('emit', event);
    }
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {

    add(state, {event, listener} ) {
        state.events.push({event, listener});
    },

    remove(state, {event, listener}) {
        let index = state.events.findIndex( (o) => o.event == event && listener == listener );

        if ( index >= 0 ) {
            state.events.splice(index, 1);
        }
    },

    emit(state, event) {
        state.events.forEach( (e) => {
            if ( e.event == event ) {
                e.listener();
            }
        });
    }
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
